import React from 'react';
import _ from 'lodash';

import ActivateLinkFormContainer from 'app/login/components/ActivateLinkFormContainer';
import ConfirmSecureSessionContainer from 'app/login/components/ConfirmSecureSessionContainer';
import CookiesDisabledFormContainer from 'app/login/components/CookiesDisabledFormContainer';
import ForgotFormContainer from 'app/login/components/ForgotFormContainer';
import LockedFormContainer from 'app/login/components/LockedFormContainer';
import LoginApp from 'app/login/components/App';
import LoginFormContainer from 'app/login/components/LoginFormContainer';
import ZapierAuthenticationLogin from 'app/login/components/ZapierIdentityAuth/ZapierAuthenticationLogin';
import ZapierAuthenticationSignUp from 'app/login/components/ZapierIdentityAuth/ZapierAuthenticationSignUp';
import { PlatformHeaderContainer } from 'app/viewport';
import ResetFormContainer from 'app/login/components/ResetFormContainer';
import SignUpFormContainer from 'app/login/components/SignUpFormContainer';
import TrackData from 'app/track/Data';
import TwoFactorAuthFormContainer from 'app/login/components/TwoFactorAuthFormContainer';
import withGlobalErrorModal from 'app/common/components/withGlobalErrorModal';

const DEFAULT_SIGN_UP_URL = '/app/onboarding';

const SignupType = {
  oneTap: 'one-tap',
  googleOneTap: 'google-one-tap',
  sso: 'sso',
  googleSso: 'google-sso',
  direct: 'direct',
  facebookSso: 'facebook-sso',
  flab: 'flab-abs',
  flabSso: 'flab-sso',
  microsoftSso: 'microsoft-sso',
};

const createLoginRoute = ({
  Component,
  promo = 'login',
  promoClass,
  renderHeader,
}) => ({
  FormComponent: withGlobalErrorModal(Component),
  component: LoginApp,
  promo,
  promoClass,
  previewType: 'login',
  isAuthRequired: false,
  assign: { renderHeader },
});

export default {
  '/app/login': createLoginRoute({ Component: LoginFormContainer }),
  '/app/login/2fa': createLoginRoute({ Component: TwoFactorAuthFormContainer }),
  '/app/login/secure-session': createLoginRoute({
    Component: ConfirmSecureSessionContainer,
  }),
  '/app/login/forgot': createLoginRoute({ Component: ForgotFormContainer }),

  // TODO: remove this route once email template is changed to /app/login/reset-password
  '/app/reset-password': createLoginRoute({ Component: ResetFormContainer }),

  '/app/login/reset-password': createLoginRoute({
    Component: ResetFormContainer,
  }),
  '/app/login/locked': createLoginRoute({ Component: LockedFormContainer }),
  '/app/login/cookies-disabled': createLoginRoute({
    Component: CookiesDisabledFormContainer,
  }),
  '/app/login/activate': createLoginRoute({
    Component: ActivateLinkFormContainer,
  }),

  '/sign-up/team-member/:appId': createLoginRoute({
    Component: SignUpFormContainer,
    promo: 'teamMember',
  }),
  '/platform/login': createLoginRoute({
    Component: ZapierAuthenticationLogin,
    promo: 'platformLogin',
    promoClass: 'platform',
    renderHeader: () => <PlatformHeaderContainer />,
  }),
  '/platform/sign-up': createLoginRoute({
    Component: ZapierAuthenticationSignUp,
    promo: 'platformSignUp',
    promoClass: 'platform',
    renderHeader: () => <PlatformHeaderContainer />,
  }),
  '/sign-up/sso/success': {
    onEnter({ routeTo, action }) {
      const nextUrl = _.get(
        action.meta,
        ['assign', 'query', 'next'],
        DEFAULT_SIGN_UP_URL
      );
      const useCaseSlug =
        _.get(action.meta, ['assign', 'query', 'use_case'], '') ||
        _.get(action.meta, ['assign', 'query', 'use_case_slug'], '');

      TrackData.trackSignupConversion(SignupType.sso, { useCaseSlug });

      // Force a hard refresh if we're in the middle of an OAuth flow, which lets Django redirect the user to the proper place.
      // TODO: we may need to add a middleware or another route which does a hard refresh
      const shouldExit = nextUrl.startsWith('/oauth/authorize/');

      routeTo(nextUrl, { replace: true, exit: shouldExit });
    },
  },
};
